<div class="main">
  <spb-header/>
  <router-outlet/>
  <div [style.flex]="1"></div>
  <spb-footer
    (logoutUser)="configService.logout()"
    [license]="true"
    [version]="version"
    [token]="(configService.accessToken$ | async)"
    copyrightYears="2025"
  />
</div>